import styled from "styled-components";

export const QueuedCardsContainer = styled.div`
    border: 1px solid rgba(255,255,255,0.25);
    border-radius: 24px;
    box-sizing: border-box;
    color: #FFFFFF;
    display: flex;
    flex-direction: column;
    gap: 8px;
    height: fit-content;
    max-height: ${(props) => props.$isCustom ? 'none' : '640px'};
    padding: 8px;
    width: 100%;
    /* background-color: green; */
`
export const QueueHeader = styled.div`
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    justify-content: space-between;
    width: 100%;

    -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;

    h3 {
        font-size: 24px;
        line-height: 24px;
        margin: 8px 0px;
        margin-left: 4px;
        opacity: 0.24;
    }

    h4 {
        background-color: rgba(255,255,255,0.4);
        border: 1px solid rgba(255,255,255,0.67);
        border-radius: 100px;
        box-sizing: border-box;
        font-size: 12px;
        line-height: 26px;
        min-width: 48px;
        opacity: 0.5;
        text-align: center;
    }
`

export const QueueHeaderLeft = styled.div`
    align-items: center;
    display: flex;
    flex: 1 1 auto;
    gap: 12px;
    min-width: 0;
`
export const QueueBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    overflow-y: ${(props) => props.$isCustom ? 'visible' : 'scroll'};
    max-height: ${(props) => props.$isCustom ? 'none' : '560px'};
`
export const QueueFooter = styled.div`
    display: flex;
    gap: 8px;
    margin: 12px 0px;

    button {
        align-items: center;
        background: none;
        border: 1px solid #FFFFFF;
        border-radius: 8px;
        color: #FFFFFF;
        cursor: pointer;
        display: flex;
        font-weight: 600;
        height: 44px;
        justify-content: center;
        width: 100%;
        gap: 8px;

        &:hover:not(:disabled) {
            background-color: rgba(255,255,255,0.25);
        }

        &:disabled {
            cursor: not-allowed;
            opacity: 0.5;
        }
    }

`

export const LoadingOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    backdrop-filter: blur(4px);
    padding: 20px;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
`;

export const LoadingContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
    color: #FFFFFF;
    text-align: center;
`;

export const LoadingText = styled.p`
    font-size: 16px;
    line-height: 24px;
    margin: 0;
    opacity: 0.9;
`;

export const QueueOddsRow = styled.div`
    border-top: 1px solid rgba(255, 255, 255, 0.15);
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    gap: 8px 10px;
    margin-top: 8px;
    padding-top: 8px;
    width: 100%;
`;